import {normalizeDesign,DECORATIONS,FINGERS} from './design-model.js';
const finger=i=>(i<5?'左手':'右手')+FINGERS[i%5];
// Screening hints use screen-space bounds; they never certify physical manufacture.
export function reviewDesign(value){
 const d=normalizeDesign(value),issues=[];
 const add=(code,message,indices=[])=>issues.push({code,message,fingerIndices:indices});
 if(d.size!=='custom')add('size','预设尺码尚未对应已确认的实物尺寸表，请商家核对十指尺寸。');
 else if(d.sizeMode==='per-finger')add('finger-size','逐指 XS / S / M / L 为尺码选择，需商家按甲型核对实际宽度。');
 else if(d.sizeMode==='tip-number')add('tip-size','甲片号需与所选甲型的实物号数表核对，不能直接换算为毫米。');
 d.nails.forEach((n,i)=>{
  const active=n.layers.filter(l=>l.visible!==false&&l.opacity!==0),charms=active.filter(l=>l.kind==='charm');
  if(active.some(l=>l.kind==='stroke'||l.kind==='sticker'))add('custom-art',finger(i)+'含手绘或自带图案，请确认工艺、细节和正式报价。',[i]);
  const circles=charms.map(l=>{
   const material=DECORATIONS.find(x=>x.id===l.type),t=l,radius=(material?.defaultSize||5)*2.5*t.scale;
   const changedColor=material?.colorable!==false&&l.color&&!['#d4b170','#d2b678',material?.color].includes(l.color);
   if(l.opacity!==1||l.clip||changedColor)add('physical-options',finger(i)+'有实体饰品的透明度、裁切或改色设定，请以实物配件确认。',[i]);
   if(t.x-radius<10||t.x+radius>90||t.y-radius<12||t.y+radius>145)add('edge',finger(i)+'的饰品可能靠近或超出甲面边缘，请商家核对固定空间。',[i]);
   return{x:t.x,y:t.y,r:radius};
  });
  if(circles.some((a,j)=>circles.some((b,k)=>k>j&&Math.hypot(a.x-b.x,a.y-b.y)<a.r+b.r)))add('overlap',finger(i)+'的饰品可能重叠，请确认层叠方式和牢固度。',[i]);
 });
 const unique=issues.filter((issue,i)=>issues.findIndex(x=>x.code===issue.code&&x.message===issue.message)===i);
 return {status:'pending_review',issues:unique,summary:unique.length?'有 '+unique.length+' 项需要核对':'仍需商家核对材料库存、尺寸与制作方式'};
}
